
import React, { useState, useEffect } from "react";

import API1 from "../Services/Auth"
import API from "../Services/Inventory"
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import CenterModal from '../Components/CenterModal'
import APISS from '../Services/Location';
import Select from "react-select";

const ManageInvetory = () => {
  const [product, setProduct] = useState([]);
  const [productId, setProductId] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [measurementUnits, setMeasurementUnits] = useState([]);
  const [measurementUnit, setMeasurementUnit] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("");
  const [location, setLocation] = useState([])
  const [remark, setRemark] = useState("");
  const [qty, setQty] = useState("");
  const [date, setdate] = useState("");
  const [productName, setProductName] = useState("");
  const [unitName, setUnitName] = useState("");
  const [unitId, setUnitId] = useState("");
  const [getId, setId] = useState("");
  const perPage = 10;
  const [errors, setErrors] = useState({});
  const [search, setSearch] = useState("")
  const [selectedCenter, setSelectedCenter] = useState([]);

  useEffect(() => {
    bindProductList();
    bindLocation();
  }, [currentPage])

  const bindLocation = async () => {
    try {
      const response = await APISS.getLocationList({
        is_active: 1,
        limit: 0,
      });
      setLocation(response?.data?.data || []);
      // setLocation1(response?.data?.data || [])
    } catch (error) {
      //setError("Failed to fetch locations.");
      console.error(error);
      if (error.response.status == 403) {
        window.location.replace("/Login");
      }
    }
  };




  const bindProductList = async () => {
    try {
      const location_id = Array.isArray(selectedCenter)

        ? selectedCenter.join(", ")
        : selectedCenter;

      const payload = {
        page_number: currentPage,
        limit: perPage,
        is_active: 1,
        search: search,
        location_id: selectedLocation
      };
      const response = await API.Get_inventory_List(payload);
      const details = response.data;
      //  console.log("details data...", details)
      setTotalRecords(details.totalCount);
      setProduct(details.data);
    } catch (error) {
      toast.dismiss();
      if (!error.response) {
        toast.error("Network error! Please check your internet connection");
      } else if (error.response.status === 403) {
        window.location.replace("/Login")
        toast.error("Network error! Please check your internet connection.");
      } else {
        toast.error("An unexpected error occurred. Please try again.");
      }
    }
  };

  const bindMeasurementUnit = async (type) => {
    const payload = {
      is_active: 1,
      //type: type
    }
    const response = await API1.bindMeasurementUnit(payload);
    // console.log('dddd',response?.data);
    setMeasurementUnits(response.data.data.rows)

  }

  const totalPages = Math.ceil(totalRecords / perPage);
  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
      // bindProductList();
    }
  };
  const handleSelectedCenter = (selectedData) => {
    setSelectedCenter(selectedData);
  };


  const handleGetData = async (id) => {
    try {
      const response = await API.Get_inventory_List({ id });

      if (response?.data?.data?.length > 0) {
        //console.log('eeeeee',response.data.data);
        bindMeasurementUnit(response.data.data[0].unit)
        setProductName(response.data.data[0].name);
        setProductId(response.data.data[0].sale_product_id);
        setId(response.data.data[0].id);
        setUnitName(response.data.data[0].unit_name);
        setUnitId(response.data.data[0].unit);
      } else {
        console.log("No data found");
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 500) {
          toast.error("Server Error: Please try again later.");
        } else if (error.response.status === 403) {
          window.location.replace("/Login");
        } else {
          toast.error(`Error ${error.response.status}:`, error.response.data);
        }
      } else {
        toast.error("Network Error or Unexpected Issue:", error.message);
      }
    }
  };

  const validateFields = () => {
    const errors = {};
    if (!qty.trim()) {
      errors.qty = "Qty Stock is required";
    } else if (isNaN(qty)) {
      errors.qty = "Qty must be a valid number";
    } else if (parseFloat(qty) <= 0) {
      errors.qty = "Qty must be greater than 0";
    }
    if (!date.trim()) {
      errors.date = "Date is required";
    }
    if (!measurementUnit?.trim()) {
      errors.measurementUnit = "Unit is required";
    }
    setErrors(errors);

    return Object.keys(errors).length === 0;

  };

  const handleFieldChange = (e, fieldName) => {
    const value = e.target.value;
    if (value.trim()) {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[fieldName];
        return updatedErrors;
      });
    }
    switch (fieldName) {
      case "qty":
        setQty(value);
        break;
      case "measurementUnit":
        setMeasurementUnit(value);
        break;
      case "remark":
        setRemark(value);
        break;
      case "date":
        setdate(value);
        break;
      default:
        break;
    }
  };

  const handleSubmit = async () => {
    if (!validateFields()) return;
    try {
      const payload = {
        name: productName,
        qty: parseInt(qty),
        unit: parseInt(measurementUnit),
        // unit: unitId,
        sale_product_id: productId,
        remark: remark,
        date: date,
      };
      const response = await API.Update_inventory(getId, payload);
      if (response.status === 200) {
        toast.success(response.data.message);
        setTimeout(() => window.location.reload(), 2000);
      } else {
        toast.error(response.data.message || "Something went wrong!");
      }
      setQty("");
      setRemark("");
      setdate("");
      setMeasurementUnit("");
    } catch (error) {
      if (error.response.status === 403) {
        window.location.replace("/Login");
      }
      if (error.response) {
        console.error("Server Error:", error.response.data);
        toast.error(
          error.response.data.message || "An error occurred while submitting data."
        );
      } else if (error.request) {
        console.error("Network Error:", error.request);
        toast.error("Network error: Please check your internet connection.");
      } else {
        console.error("Error:", error.message);
        toast.error("An unexpected error occurred.");
      }
    }
  };

  const handleClose = async () => {
    window.location.reload();
  }

  const handleFieldChange1 = (e, fieldName) => {
    const value = e.target.value;
    if (fieldName === "search") {
      setSearch(value);
      if (value.trim() === "") {
        setCurrentPage(1);
        bindProductList(1);
      }
    }
  };


  const handleSearch = () => {
    if (search.trim() === "") {
      setCurrentPage(1);
      bindProductList(1);
    } else {
      setCurrentPage(1);
      bindProductList(1);
    }
  };

  const getPageNumbers = () => {
    const maxVisible = 10;
    const pageNumbers = [];
    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      const left = Math.max(1, currentPage - 3);
      const right = Math.min(totalPages, currentPage + 3);
      if (left > 2) {
        pageNumbers.push(1, '...');
      } else {
        for (let i = 1; i < left; i++) {
          pageNumbers.push(i);
        }
      }
      for (let i = left; i <= right; i++) {
        pageNumbers.push(i);
      }
      if (right < totalPages - 1) {
        pageNumbers.push('...', totalPages);
      } else {
        for (let i = right + 1; i <= totalPages; i++) {
          pageNumbers.push(i);
        }
      }
    }
    return pageNumbers;
  };
  const locationOptions = location.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  return (
    <div>
      <div className="col-lg-12 grid-margin stretch-card">
        <div className="card">
          {/* Card Header */}
          <div className="card-header d-flex justify-content-between align-items-center">
            <h4 className="card-title mb-0">Product List</h4>
          </div>

          <div className="card-body">
            <div className="row mb-3">
              {/* <div className="col-md-4">
                <label htmlFor="ddSalesType" className="form-label">
                  <b>Center Name</b>
                </label>

                <Select
                  id="ddSalesType"
                  options={locationOptions}
                  placeholder="Select Center"
                  isSearchable={true}
                  value={locationOptions.find(
                    (opt) => opt.value === selectedLocation
                  )}
                  onChange={(selectedOption) =>
                    setSelectedLocation(selectedOption?.value)
                  }
                />
              </div> */}
              <div className="col-md-4">
                <b>Search by Name</b  >
                <input type="text" class="form-control" placeholder="Search by Name"
                  value={search}
                  onChange={(e) => handleFieldChange1(e, "search")}
                />
              </div>
              <div className="col-md-2 mt-3">
                <button onClick={handleSearch} class="btn btn-success" type="button">Search</button>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-bordered text-center">
                <thead>
                  <tr>
                    <th>Sr No</th>
                    {/* <th>Action</th> */}
                    <th>Name</th>
                    {/* <th>Center Name</th>
                    <th>Current Stock</th> */}
                    <th>Unit Name</th>
                    <th>Created-Date</th>
                  </tr>
                </thead>
                <tbody>
                  {product.map((item, index) => (
                    <tr key={item.id}>
                      <td>{(currentPage - 1) * perPage + index + 1}</td>
                      {/* <td>
                        <button className="btn btn-success btn-sm"
                          onClick={() => handleGetData(item.id)}
                          data-bs-toggle="modal" data-bs-target="#staticBackdrop">Add Stock</button>{' '}
                      </td> */}
                      <td>{item.product_name == 'recipe' ? item.name : item.product_name}</td>
                      {/* <td>{item?.location_name}</td>
                      <td>{item.qty}</td> */}
                      <td>{item.unit_name}</td>
                      <td>
                        {moment(item.createdAt).format("DD-MM-YYYY")}
                      </td>

                    </tr>
                  ))}
                </tbody>

              </table>
              <nav aria-label="Page navigation example">
                <ul className="pagination justify-content-center mt-4">

                  <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      Previous
                    </button>
                  </li>

                  {getPageNumbers().map((page, index) => (
                    <li
                      key={index}
                      className={`page-item ${page === currentPage ? "active" : ""} ${page === "..." ? "disabled" : ""}`}
                    >
                      {page === "..." ? (
                        <span className="page-link">...</span>
                      ) : (
                        <button className="page-link" onClick={() => handlePageChange(page)}>
                          {page}
                        </button>
                      )}
                    </li>
                  ))}

                  <li
                    className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                  >
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      Next
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <section>
        <div
          className="modal fade"
          id="staticBackdrop"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog modal-dialog-centered modal-lg"
            style={{ width: "900px" }}
          >
            <div className="modal-content" style={{ backgroundColor: "#fff" }}>
              <div className="modal-header">
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <table
                  className="table table-bordered text-center"
                  style={{ tableLayout: "fixed", width: "100%" }}
                >
                  <thead>
                    <tr>
                      <th style={{ width: "33.33%" }}>Product Name</th>
                      <th style={{ width: "33.33%" }}>Qty <span style={{ color: "red" }}>*</span></th>
                      <th style={{ width: "33.33%" }}>Unit <span style={{ color: "red" }}>*</span></th>
                      <th style={{ width: "33.33%" }}>Date <span style={{ color: "red" }}>*</span></th>
                      <th style={{ width: "33.33%" }}>Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{productName}</td>
                      <td>
                        <input
                          type="text"
                          className={`form-control ${errors.qty ? "is-invalid" : ""}`}
                          id="txtqty"
                          placeholder="Enter Quantity"
                          value={qty}
                          onChange={(e) => handleFieldChange(e, "qty")}
                        />
                        {errors.qty && <div className="invalid-feedback">{errors.qty}</div>}
                      </td>
                      <td>
                        {/* {unitName} */}
                        <select
                          className={`form-select ${errors.measurementUnit ? "is-invalid" : ""
                            }`}
                          id="ddMeasurementUnit"
                          value={measurementUnit}
                          onChange={(e) => handleFieldChange(e, "measurementUnit")}
                        >
                          <option value="">Select Unit</option>
                          {measurementUnits && measurementUnits.map((unit) => (
                            <option key={unit.id} value={unit.id}>
                              {unit.name}
                            </option>
                          ))}
                        </select>
                        {errors.measurementUnit && (
                          <div className="invalid-feedback">{errors.measurementUnit}</div>
                        )}
                      </td>

                      <td>
                        <input
                          type="date"
                          className={`form-control ${errors.date ? "is-invalid" : ""}`}
                          id="txtdate"
                          value={date}
                          max={new Date().toISOString().split("T")[0]}
                          onChange={(e) => handleFieldChange(e, "date")}
                        />
                        {errors.date && <div className="invalid-feedback">{errors.date}</div>}
                      </td>
                      <td>
                        <input
                          type="text"
                          className={`form-control ${errors.remark ? "is-invalid" : ""}`}
                          id="txtremarks"
                          placeholder="Enter Remarks"
                          value={remark}
                          onChange={(e) => handleFieldChange(e, "remark")}
                        />
                        {errors.remark && (
                          <div className="invalid-feedback">{errors.remark}</div>
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                  onClick={handleClose}
                >
                  Close
                </button>
                <button type="button" className="btn btn-primary" onClick={handleSubmit}>
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer />
    </div>

  );
};

export default ManageInvetory;
